import React from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
    meta?: {
        title?: string;
        description?: string;
    };
    structuredData?: string;
    canonicalUrl?: string;
}

export const HelmetPageMeta: React.FC<Props> = ({ meta, structuredData, canonicalUrl }) => (
    <Helmet>
        {meta && typeof meta.title === 'string' && <title>{meta.title}</title>}
        {meta && typeof meta.description === 'string' && (
            <meta name="description" content={meta.description} />
        )}
        {typeof structuredData === 'string' && (
            <script type="application/ld+json">{structuredData}</script>
        )}
        {typeof canonicalUrl === 'string' && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
);
